import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state:{
    songid:'',
    rightdata:[],
    firstplay:false,
    playstate:false,
    songlist:[],
  },
  getters:{

  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js